<template>
  <window-layout>
    <h1>{{ $t('v.selectAccount.title') }}</h1>
    <v-card>
      <div class="account-list-wrapper" v-loading="loading">
        <template v-if="!loading">
          <div class="account-list" v-if="accountList.length">
            <div
              class="account-list__item"
              v-for="account in accountList"
              :key="account.directLogin"
              @click="selectAccount(account)"
            >
              <template v-if="account.name">{{ account.name }} -</template>
              {{ account.directLogin }}
            </div>
          </div>
          <div class="account-list" v-else>
            <div class="account-list__empty-text">
              <span v-html="$t('v.selectAccount.messageEmptyList')"></span>
            </div>

            <v-row justify="center">
              <v-button theme="primary" @click="logout">{{ $t('v.selectAccount.buttonHome') }}</v-button>
            </v-row>
          </div>
        </template>
      </div>
    </v-card>
  </window-layout>
</template>

<script>
import VCard from '@/components/common/VCard.vue'
import VRow from '@/components/common/VRow.vue'
import * as type from '@/store/types'
import WindowLayout from '@/layouts/Window.vue'
import { DASHBOARD_ENTRY_ROUTE_NAME } from '@/constants/routes'

export default {
  name: 'SelectAccount',
  components: {
    WindowLayout,
    VCard,
    VRow
  },
  computed: {
    loading() {
      return this.$store.state[type.SESSION].loading
    },
    accountList() {
      return this.$store.state[type.SESSION].model.accounts || []
    }
  },
  methods: {
    logout() {
      this.$store.dispatch(type.REMOVE_SESSION)
      this.$router.push({ name: 'home' })
    },
    selectAccount({ directLogin }) {
      const { commit, dispatch, state } = this.$store
      const { user: oldUser } = state[type.SESSION].model
      const { userId, username } = oldUser
      const user = { userId, username, directLogin }

      commit(type.UPDATE_MODEL, { name: type.SESSION, model: { user } })

      dispatch(type.ADD_ACTION_IN_QUEUE, {
        type: type.SELECT_ACCOUNT,
        payload: user,
        name: type.SESSION
      })
        .then(() => {
          this.$router.push({ name: DASHBOARD_ENTRY_ROUTE_NAME })
        })
        .catch(() => {
          commit(type.SET_MODEL, {
            name: type.SESSION,
            model: { user: oldUser }
          })
        })
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../assets/style/scss/vars.scss";

$account-item-height: 54px;

.account-list-wrapper {
  position: relative;
  min-height: 50px;
}

.account-list {
  overflow-y: auto;
  max-height: $account-item-height * 5;
}

.account-list__item {
  cursor: pointer;
  height: $account-item-height;
  line-height: $account-item-height;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  font-size: 22px;
  transition: all 0.3s ease-in-out;

  &:not(:last-child) {
    border-bottom: 1px solid $border-color-base;
  }

  &:hover {
    background-color: $alice;
  }
}
.account-list__empty-text {
  margin-bottom: 20px;
}
</style>
